import React, {Fragment} from 'react';

import {Box, Stack, Typography, useTheme} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {Message} from './Message';
import {Accordion} from './Accordion';
import {MessagesProps} from './Message/types';

const {messagesTitle, noMessages} = translations['pt-br'].privateFlow.requestAuthorizations.detail;

export function Messages({messages}: MessagesProps) {
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();

	const seeMore = messages.length > 1;
	const hasMessages = messages.length > 0;

	return (
		<Stack
			bgcolor={'background.paper'}
			marginY={isMobile ? 2 : 3}
			borderRadius={1}
			gap={2}
			p={2}>
			<Typography variant="body2" fontWeight={600} color="text.secondary">
				{messagesTitle}
			</Typography>
			<Stack gap={1}>
				{hasMessages ? (
					<Fragment>
						<Message {...messages[0]} />
						{seeMore ? (
							<Accordion
								title={`Ver mais (${messages.length - 1})`}
								dataTagId={AutoSolEnum.AS_CLICK_VER_MAIS}>
								<Stack gap={2}>
									{messages.slice(1).map((message, index) => (
										<Message key={index} {...message} />
									))}
								</Stack>
							</Accordion>
						) : null}
					</Fragment>
				) : (
					<Box display="flex" flexDirection="row" alignItems="center" gap={1}>
						<Icon name="dialog-filled" color={colors.brand.primary.blue} />
						<Typography variant="body2" color="text.secondary">
							{noMessages}
						</Typography>
					</Box>
				)}
			</Stack>
		</Stack>
	);
}
